import React, { useState, useEffect, useMemo } from 'react';
import NumericKeypad from '../Conf/NumericKeyPad';
import RentDressServiceDialog from './RentDressServiceDialog';
import RentableItemDialog from './RentableItemDialog';
import ServiceCard from './ServiceCard';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Tooltip from '@mui/material/Tooltip';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Bill from '../../../assets/pictures/bill.png';
import BillBlack from '../../../assets/pictures/bill_black.png';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useMediaQuery, Box, Typography, Card, CardContent, IconButton, Button, Tabs, Tab, Grid, Paper, Fab, Chip, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText } from '@mui/material';
import ClientDialog from './ClientDialog';
import NewClientDialog from './NewClientDialog';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { message } from 'antd';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';

import '../../../Styles/Interface/Services/AdditionalServices.css';

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, values, handleChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="#00-000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

// --- Constants ---
const MAX_DISCOUNT_PERCENT = 35;
const DRESS_SERVICE_TYPE = 'Vestidos';
const SUIT_SERVICE_TYPE = 'Trajes'; // <-- NUEVA CONSTANTE
const XV_DRESS_SERVICE_ID = 12;
const WEDDING_DRESS_SERVICE_ID = 22;
const PERSONAL_DRESS_SERVICE_ID = 13;
const CHILD_DRESS_SERVICE_ID = 14;
const SUIT_SERVICE_ID = 35; // <-- NUEVA CONSTANTE (¡IMPORTANTE: AJUSTA ESTE ID AL CORRECTO EN TU DB!)
const PAYMENT_STATUS_PAID = 'pagado';
const PAYMENT_STATUS_PENDING = 'pendiente';
// ---

const safeParseFloat = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace(/,/g, ''));
    return isNaN(parsed) ? defaultValue : parsed;
  }
  return defaultValue;
};

const formatCurrency = (value) => {
  return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};


function BillingServiceSelector({ reservation, nextStepHandler, updateSelectedServices, selectedServices, services, arrOfServiceTypes,
  dressList, suitList, handleServicesInvoice, dressReservations, suitReservations, clientsList, handleClientSelection, client,
  handleScheduleDate, requestClients, newDressReservation }) {

  const [arrOfSelectedServices, setArrOfSelectedServices] = useState([]);
  const [serviceType, setServiceType] = useState(
    arrOfServiceTypes.length > 0 ? arrOfServiceTypes[0].serviceType : 'Enmarcados'
  );
  const [selectedService, setSelectedService] = useState(null);
  const [isFirstKey, setIsFirstKey] = useState(true);
  const [changeQty, setChangeQty] = useState(true);
  const [changePrice, setChangePrice] = useState(false);
  const [changeDiscount, setChangeDiscount] = useState(false);
  const [editPaidService, setEditPaidService] = useState(false);
  const [paidService, setPaidService] = useState(false);

  // Estados para los diálogos de selección
  const [openXVDressDialog, setOpenXVDressDialog] = useState(false);
  const [openWDressDialog, setOpenWDressDialog] = useState(false);
  const [openPersonalDressDialog, setOpenPersonalDressDialog] = useState(false);
  const [openChildDressDialog, setOpenChildDressDialog] = useState(false);
  const [openSuitDialog, setOpenSuitDialog] = useState(false);
  const [openChildSuitDialog, setOpenChildSuitDialog] = useState(false);

  const [itemSelectionService, setItemSelectionService] = useState(null);

  // Estados para las listas de artículos
  const [XVDressList, setXVDressList] = useState([]);
  const [WDressList, setWDressList] = useState([]);
  const [personalDressList, setPersonalDressList] = useState([]);
  const [childDressList, setChildDressList] = useState([]);
  const [menSuitList, setMenSuitList] = useState([]);
  const [childSuitList, setChildSuitList] = useState([]);

  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState(false);
  const [openDiagTwo, setOpenDiagTwo] = useState(false);
  const [selectedClient, setSelectedClient] = useState({});
  const [isServiceSelectorOpen, setIsServiceSelectorOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null); // Estado generalizado para edición

  const openServiceSelector = () => setIsServiceSelectorOpen(true);
  const closeServiceSelector = () => setIsServiceSelectorOpen(false);

  const handleMobileServiceSelected = (service) => {
    handleArrOfSelectedServices(service);
    closeServiceSelector();
  };

  const tabOptions = useMemo(() =>
    arrOfServiceTypes.filter(type => type.serviceType !== 'Inventario' && type.serviceType !== 'Eventos'),
    [arrOfServiceTypes]
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleSelectedQty = (prevSelected, service) => {
    const existingService = prevSelected.find(item => item.serviceName === service.serviceName);
    if (existingService) {
      return prevSelected.map(item =>
        item.serviceName === service.serviceName ? { ...item, quantity: item.quantity + 1 } : item
      )
    } else {
      return [...prevSelected, { ...service, quantity: 1, discountApplied: 0, priceWDisc: 0, amountPaid: 0 }]
    }
  }

  const handleArrOfSelectedServices = (service) => {
    setItemSelectionService(service);
    if (service.serviceType === DRESS_SERVICE_TYPE) {
      if (service.serviceID === XV_DRESS_SERVICE_ID) return setOpenXVDressDialog(true);
      if (service.serviceID === WEDDING_DRESS_SERVICE_ID) return setOpenWDressDialog(true);
      if (service.serviceID === PERSONAL_DRESS_SERVICE_ID) return setOpenPersonalDressDialog(true);
      if (service.serviceID === CHILD_DRESS_SERVICE_ID) return setOpenChildDressDialog(true);
    }

    if (service.serviceType === SUIT_SERVICE_TYPE) {
      if (service.serviceID === SUIT_SERVICE_ID) return setOpenSuitDialog(true);
      if (service.serviceID === 36) return setOpenChildSuitDialog(true);
    }

    setArrOfSelectedServices(prevSelected => {
      const updatedServices = handleSelectedQty(prevSelected, service);
      const foundService = updatedServices.find(item => item.serviceName === service.serviceName);
      if (foundService) {
        const priceToUse = foundService.priceWDisc > 0 ? foundService.priceWDisc : foundService.servicePrice;
        foundService.totalPrice = priceToUse * foundService.quantity;
      }
      setSelectedService(foundService ? { ...foundService } : { ...service, quantity: 1, discountApplied: 0, priceWDisc: 0, amountPaid: 0, totalPrice: service.servicePrice });
      paidServiceIsActive(service);
      return updatedServices;
    });
  };

  const deleteArrOfSelectedServices = (value) => {
    if (value.serviceType === DRESS_SERVICE_TYPE || value.serviceType === SUIT_SERVICE_TYPE) {
      handleScheduleDate(null, null, value, 'remove-all');
    }
    const updatedServices = arrOfSelectedServices.filter(service => service !== value);
    setArrOfSelectedServices(updatedServices);
    setSelectedService(null);
    paidServiceIsActive(false);
  }

  // --- Lógica Generalizada para Manejar Artículos (Vestidos y Trajes) ---
  const handleItemSelectionLogic = (item, service, dates) => {
    const isDress = service.serviceType === DRESS_SERVICE_TYPE;
    const itemsKey = isDress ? 'dresses' : 'suits';
    const itemIDKey = isDress ? 'dressID' : 'suitID';

    const action = editingItem ? 'update' : 'add';
    const oldItem = editingItem ? editingItem.itemData.item : null;
    handleScheduleDate(dates, item, service, action, oldItem);

    setArrOfSelectedServices(prevSelected => {
      const serviceIndex = prevSelected.findIndex(s => s.serviceID === service.serviceID);

      if (editingItem) {
        const updatedServices = [...prevSelected];
        const serviceToUpdate = { ...updatedServices[serviceIndex] };
        serviceToUpdate[itemsKey] = serviceToUpdate[itemsKey].map(d =>
          d.item[itemIDKey] === editingItem.itemData.item[itemIDKey] ? { item, dates } : d
        );
        updatedServices[serviceIndex] = serviceToUpdate;
        setEditingItem(null);
        return updatedServices;
      }

      if (serviceIndex > -1) {
        const updatedServices = [...prevSelected];
        const serviceToUpdate = { ...updatedServices[serviceIndex] };
        serviceToUpdate[itemsKey] = [...(serviceToUpdate[itemsKey] || []), { item, dates }];
        serviceToUpdate.quantity = serviceToUpdate[itemsKey].length;
        const priceToUse = serviceToUpdate.priceWDisc > 0 ? serviceToUpdate.priceWDisc : safeParseFloat(serviceToUpdate.servicePrice);
        serviceToUpdate.totalPrice = priceToUse * serviceToUpdate.quantity;
        updatedServices[serviceIndex] = serviceToUpdate;
        setSelectedService({ ...serviceToUpdate });
        return updatedServices;
      } else {
        const newService = {
          ...service,
          quantity: 1,
          discountApplied: 0,
          priceWDisc: 0,
          amountPaid: 0,
          totalPrice: safeParseFloat(service.servicePrice),
          [itemsKey]: [{ item, dates }],
          paymentStatus: PAYMENT_STATUS_PENDING
        };
        setSelectedService({ ...newService });
        paidServiceIsActive(service);
        return [...prevSelected, newService];
      }
    });
  };

  const handleSelectedDress = (dress, service, dates) => handleItemSelectionLogic(dress, service, dates);
  const handleSelectedSuit = (suit, service, dates) => handleItemSelectionLogic(suit, service, dates);

  const handleDeleteItem = (service, itemToDelete) => {
    handleScheduleDate(null, itemToDelete.item, service, 'remove');
    setArrOfSelectedServices(prevSelected => {
      const serviceIndex = prevSelected.findIndex(s => s.serviceID === service.serviceID);
      if (serviceIndex === -1) return prevSelected;

      const serviceToUpdate = { ...prevSelected[serviceIndex] };
      const isDress = service.serviceType === DRESS_SERVICE_TYPE;
      const itemsKey = isDress ? 'dresses' : 'suits';
      const itemIDKey = isDress ? 'dressID' : 'suitID';

      serviceToUpdate[itemsKey] = serviceToUpdate[itemsKey].filter(
        d => d.item[itemIDKey] !== itemToDelete.item[itemIDKey]
      );

      if (serviceToUpdate[itemsKey].length === 0) {
        if (selectedService?.serviceID === service.serviceID) setSelectedService(null);
        return prevSelected.filter(s => s.serviceID !== service.serviceID);
      } else {
        serviceToUpdate.quantity = serviceToUpdate[itemsKey].length;
        const priceToUse = serviceToUpdate.priceWDisc > 0 ? serviceToUpdate.priceWDisc : safeParseFloat(serviceToUpdate.servicePrice);
        serviceToUpdate.totalPrice = priceToUse * serviceToUpdate.quantity;
        const updatedServices = [...prevSelected];
        updatedServices[serviceIndex] = serviceToUpdate;
        if (selectedService?.serviceID === service.serviceID) {
          setSelectedService({ ...serviceToUpdate });
        }
        return updatedServices;
      }
    });
  };

  const handleEditItem = (service, itemData) => {
    setEditingItem({ service, itemData });
    setItemSelectionService(service);
    if (service.serviceType === DRESS_SERVICE_TYPE) {
      if (service.serviceID === XV_DRESS_SERVICE_ID) setOpenXVDressDialog(true);
      else if (service.serviceID === WEDDING_DRESS_SERVICE_ID) setOpenWDressDialog(true);
      else if (service.serviceID === PERSONAL_DRESS_SERVICE_ID) setOpenPersonalDressDialog(true);
      else if (service.serviceID === CHILD_DRESS_SERVICE_ID) setOpenChildDressDialog(true);
    } else if (service.serviceType === SUIT_SERVICE_TYPE) {
      if (service.serviceID === SUIT_SERVICE_ID) return setOpenSuitDialog(true);
      else if (service.serviceID === 36) return setOpenChildSuitDialog(true);
    }
  };

  // --- Funciones de Teclado, Pagos y UI (Sin cambios) ---
  const handleKeyClick = (key) => {
    if (changeQty) {
      if (selectedService.serviceType === 'Vestidos' || selectedService.serviceType === 'Trajes') return;
      setSelectedService(prev => ({ ...prev, quantity: isFirstKey ? key : prev.quantity * 10 + key }));
      return setIsFirstKey(false);
    }
    if (changePrice) {
      setSelectedService(prev => ({ ...prev, servicePrice: isFirstKey ? key : prev.servicePrice * 10 + key }));
      return setIsFirstKey(false);
    }
    if (changeDiscount) {
      setSelectedService(prev => ({ ...prev, discountApplied: isFirstKey ? key : prev.discountApplied * 10 + key }));
      return setIsFirstKey(false);
    }
    if (paidService && editPaidService) {
      setSelectedService(prev => {
        const newAmountPaid = isFirstKey ? key : prev.amountPaid * 10 + key;
        const maxAmount = (typeof prev.servicePrice === 'string' ? parseFloat(prev.servicePrice.replace(/,/g, '')) : Number(prev.servicePrice)) * prev.quantity;
        return { ...prev, amountPaid: newAmountPaid > maxAmount ? maxAmount : newAmountPaid };
      });
      return setIsFirstKey(false);
    }
  };

  const handleBackspaceClick = () => {
    if (changeQty) {
      if (selectedService.quantity === 0) {
        deleteArrOfSelectedServices(selectedService);
        return setSelectedService(null);
      }
      if (selectedService.serviceType === 'Vestidos' || selectedService.serviceType === 'Trajes') return;
      return setSelectedService(prev => ({ ...prev, quantity: Math.floor(prev.quantity / 10) }));
    }
    if (changePrice) {
      if (selectedService.servicePrice === 0) {
        let service = services.find(item => item.serviceName === selectedService.serviceName);
        return setSelectedService((prev) => ({ ...prev, servicePrice: safeParseFloat(service.servicePrice) }));
      }
      return setSelectedService(prev => ({ ...prev, servicePrice: Math.floor(safeParseFloat(prev.servicePrice) / 10) }));
    }
    if (changeDiscount) {
      return setSelectedService(prev => ({ ...prev, discountApplied: Math.floor(prev.discountApplied / 10) }));
    }
    if (paidService && editPaidService) {
      return setSelectedService(prev => ({ ...prev, amountPaid: Math.floor(prev.amountPaid / 10) }));
    }
  };

  const handleClearClick = () => {
    if (changeQty) {
      if (selectedService.serviceType === 'Vestidos' || selectedService.serviceType === 'Trajes') return;
      setSelectedService(prev => ({ ...prev, quantity: 0 }));
      return setIsFirstKey(true);
    }
    if (changePrice) {
      setSelectedService(prev => ({ ...prev, servicePrice: 0 }));
      return setIsFirstKey(true);
    }
    if (changeDiscount) {
      setSelectedService(prev => ({ ...prev, discountApplied: 0, priceWDisc: 0 }));
      return setIsFirstKey(true);
    }
    if (paidService && editPaidService) {
      setSelectedService(prev => ({ ...prev, amountPaid: 0 }));
      return setIsFirstKey(true);
    }
  };

  const handleChangeValues = () => {
    if (!selectedService) return;

    setArrOfSelectedServices(prevSelected => prevSelected.map(service => {
      if (service.serviceID !== selectedService.serviceID) {
        return service;
      }

      const isRentable = service.serviceType === DRESS_SERVICE_TYPE || service.serviceType === SUIT_SERVICE_TYPE;

      // --- Define variables base según qué campo se está editando ---
      const quantity = !isRentable && changeQty ? selectedService.quantity : service.quantity;
      const basePrice = changePrice ? selectedService.servicePrice : service.servicePrice;
      const discountApplied = changeDiscount
        ? Math.min(selectedService.discountApplied || 0, MAX_DISCOUNT_PERCENT)
        : service.discountApplied || 0;

      // --- Recalcula los precios ---
      const priceWDisc = discountApplied > 0
        ? safeParseFloat(basePrice) * (1 - discountApplied / 100)
        : safeParseFloat(basePrice);

      const totalPrice = priceWDisc * quantity;

      // --- Recalcula el monto pagado ---
      const newAmountPaid = (paidService && editPaidService)
        ? Math.min(selectedService.amountPaid || 0, totalPrice)
        : Math.min(service.amountPaid || 0, totalPrice);

      const paymentStatus = newAmountPaid >= totalPrice ? PAYMENT_STATUS_PAID : PAYMENT_STATUS_PENDING;

      return {
        ...service,
        quantity,
        servicePrice: basePrice,
        discountApplied,
        priceWDisc,
        totalPrice,
        amountPaid: newAmountPaid,
        paymentStatus
      };
    }));
  };

  const handleSelectedServiceChanges = (service) => {
    const foundService = arrOfSelectedServices.find(item => item.serviceName === service.serviceName);
    const serviceToSelect = foundService || service;
    setSelectedService(serviceToSelect);
    if (paidService && editPaidService) {
      setEditPaidService(false);
      setChangeQty(true);
    }
    paidServiceIsActive(serviceToSelect);
  };

  const paidServiceIsActive = (service) => {
    if (service) {
      const foundService = arrOfSelectedServices.find(item => item.serviceName === service.serviceName);
      setPaidService(foundService && foundService.amountPaid > 0);
    } else {
      setPaidService(false);
    }
    if (!service || !(arrOfSelectedServices.find(item => item.serviceName === service.serviceName)?.amountPaid > 0)) {
      setEditPaidService(false);
    }
  };

  const handleActiveChangeQty = () => {
    if (changePrice || changeDiscount) {
      setChangePrice(false);
      setChangeDiscount(false);
      setChangeQty(true);
      const foundService = arrOfSelectedServices.find(item => item.serviceName === selectedService.serviceName);
      if (foundService) setSelectedService(foundService);
    }
  };

  const handleActiveChangePrice = () => {
    if (changeQty || changeDiscount) {
      setChangeQty(false);
      setChangeDiscount(false);
      setChangePrice(true);
      let foundService = arrOfSelectedServices.find(item => item.serviceName === selectedService.serviceName);
      if (foundService) setSelectedService(foundService);
    }
  };

  const handleActiveChangeDiscount = () => {
    if (changeQty || changePrice) {
      setChangeQty(false);
      setChangePrice(false);
      setChangeDiscount(true);
      const foundService = arrOfSelectedServices.find(item => item.serviceName === selectedService.serviceName);
      if (foundService) setSelectedService(foundService);
    }
  };

  const handleActiveEditPaidService = () => {
    if (editPaidService && paidService) {
      setEditPaidService(false);
      return setChangeQty(true);
    }
    if (!editPaidService && paidService) {
      setChangeQty(false);
      setChangeDiscount(false);
      setChangePrice(false);
      const foundService = arrOfSelectedServices.find(item => item.serviceName === selectedService.serviceName);
      if (foundService) {
        setSelectedService(foundService);
        setEditPaidService(true);
      }
    }
  };

  const handleActivePaidService = () => {
    if (selectedService) {
      let service = arrOfSelectedServices.find(item => item.serviceName === selectedService.serviceName);
      if (!service || service.amountPaid > 0) return setPaidService(true);

      let price = service.priceWDisc > 0 ? service.priceWDisc : safeParseFloat(service.servicePrice);
      setArrOfSelectedServices(prevSelected => prevSelected.map(s =>
        s.serviceID === selectedService.serviceID ? { ...s, amountPaid: price * selectedService.quantity, paymentStatus: 'Pagado' } : s
      ));
      setPaidService(true);
    }
  };

  const handleInactivePaidService = () => {
    if (selectedService) {
      let service = arrOfSelectedServices.find(item => item.serviceName === selectedService.serviceName);
      if (paidService && service?.amountPaid > 0) {
        setArrOfSelectedServices(prevSelected => prevSelected.map(s =>
          s.serviceName === selectedService.serviceName ? { ...s, amountPaid: 0, paymentStatus: 'Pendiente' } : s
        ));
        setPaidService(false);
      }
    }
  };

  const calculateTotal = () => arrOfSelectedServices.reduce((acc, service) => acc + safeParseFloat(service.totalPrice), 0);

  const handleToCheckOut = (e) => {
    if (arrOfSelectedServices.length === 0) {
      messageApi.warning('Debes seleccionar al menos un servicio para facturar');
      return;
    }
    if (!selectedClient || Object.keys(selectedClient).length === 0) {
      messageApi.warning('Debe seleccionar un cliente al cual facturar');
      return;
    }
    if (selectedClient?.clientID === 1) {
      for (const element of arrOfSelectedServices) {
        if (element.amountPaid < element.totalPrice) {
          messageApi.open({ content: <span>El servicio <b>{element.serviceName}</b> debe estar pagado para <b>clientes al contado</b>.</span>, icon: <WarningAmberIcon /> });
          return;
        }
        if (element.serviceType === DRESS_SERVICE_TYPE || element.serviceType === SUIT_SERVICE_TYPE) {
          messageApi.open({ content: <span>No se puede reservar el servicio <b>{element.serviceName}</b> para <b>clientes al contado</b>.</span>, icon: <WarningAmberIcon /> });
          return;
        }
      }
    }
    updateSelectedServices(arrOfSelectedServices);
    handleServicesInvoice(arrOfSelectedServices);
    nextStepHandler(e);
  };

  // --- Hooks de Efecto ---
  useEffect(() => { handleChangeValues(); }, [selectedService, changeQty, changePrice, changeDiscount, editPaidService]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      const key = event.key;
      if (key === ' ' || !selectedService) return;
      const handlers = { '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9 };
      if (key in handlers) {
        const value = handlers[key];
        if (changeQty || changePrice || changeDiscount || (paidService && editPaidService)) handleKeyClick(value);
      } else if (key === 'Backspace') {
        if (changeQty || changePrice || changeDiscount || (paidService && editPaidService)) handleBackspaceClick();
      } else if (key.toLowerCase() === 'c') {
        if (changeQty || changePrice || changeDiscount || (paidService && editPaidService)) handleClearClick();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedService, changePrice, changeDiscount, changeQty, paidService, editPaidService, isFirstKey]);

  useEffect(() => {
    setArrOfSelectedServices(selectedServices);
  }, []);

  useEffect(() => {
    const XVdresses = dressList.filter(dress => dress.dressType === 'xv');
    const Wdresses = dressList.filter(dress => dress.dressType === 'wedding');
    const personalDresses = dressList.filter(dress => dress.dressType === 'personal');
    const childDresses = dressList.filter(dress => dress.dressType === 'girls');
    setXVDressList(XVdresses);
    setWDressList(Wdresses);
    setPersonalDressList(personalDresses);
    setChildDressList(childDresses);
  }, [dressList]);

  useEffect(() => {
    const menSuits = suitList.filter(suit => suit.suitType === 'men');
    setMenSuitList(menSuits);
    const childSuits = suitList.filter(suit => suit.suitType === 'child');
    setChildSuitList(childSuits);
  }, [suitList]);

  useEffect(() => {
    if (client && Object.keys(client).length > 0 && Object.keys(selectedClient).length === 0) {
      setSelectedClient(client);
    }
  }, [client]);

  const handleTabChange = (event, newValue) => setServiceType(newValue);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleClientSelectionChange = (id) => {
    const selected = clientsList.find(c => c.clientID == id);
    setSelectedClient(selected || null);
    handleClientSelection(selected || null);
  };
  const handleClientCreation = (newClient) => {
    setSelectedClient(newClient);
    handleClientSelection(newClient);
    requestClients();
  };

  // --- Vistas de Renderizado ---
  const MobileView = () => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '99dvh', position: 'relative', overflow: 'hidden' }}>
        <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 1, paddingBottom: '80px' }}>
          <Paper elevation={2} sx={{ mb: 1 }}>
            <Box sx={{ p: 1, backgroundColor: 'aliceblue', textAlign: 'center' }}>
              <Typography variant="h6" sx={{ color: '#f759ab' }}>Servicios Seleccionados</Typography>
            </Box>
            <Box sx={{ maxHeight: '25vh', overflowY: 'auto', minHeight: '25vh' }}>
              {arrOfSelectedServices.map((service) => {
                const isSelected = selectedService?.serviceName === service.serviceName;
                const isRentable = (service.serviceType === DRESS_SERVICE_TYPE && service.dresses) || (service.serviceType === SUIT_SERVICE_TYPE && service.suits);

                if (isRentable) {
                  const isDress = service.serviceType === DRESS_SERVICE_TYPE;
                  const items = isDress ? service.dresses : service.suits;
                  const itemType = isDress ? 'vestido' : 'traje';
                  return (
                    <Accordion key={service.serviceID} disableGutters elevation={0} sx={{ backgroundColor: isSelected ? '#e6f2f3' : 'transparent', borderLeft: isSelected ? '5px solid #f759ab' : 'none', borderBottom: '1px solid #eee', '&:before': { display: 'none' } }} onClick={() => handleSelectedServiceChanges(service)}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ p: 1, minHeight: 'auto', '& .MuiAccordionSummary-content': { m: 0, justifyContent: 'space-between', alignItems: 'center' } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{service.serviceName}</Typography>
                            <Typography variant="body2" color="text.secondary">
                              {service.quantity} {itemType}{service.quantity > 1 ? 's' : ''}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {service.quantity} x RD$ {formatCurrency(safeParseFloat(service.servicePrice))}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, pr: 2 }}>
                              RD$ {formatCurrency(service.totalPrice)}
                            </Typography>
                            {
                              service.discountApplied > 0 && (
                                <Typography variant="caption" color="text.secondary" sx={{ color: 'error.main', fontStyle: 'italic', fontSize: '0.75rem' }}>
                                  Descuento apl.: {service.discountApplied}%
                                </Typography>
                              )
                            }
                          </Box>
                        </Box>
                        <IconButton size="small" sx={{ ml: 0.5, p: 0.5 }} onClick={(e) => { e.stopPropagation(); deleteArrOfSelectedServices(service); }}><DeleteOutlineIcon fontSize="small" sx={{ color: 'red' }} /></IconButton>
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, backgroundColor: '#fafafa' }}>
                        <List dense disablePadding>
                          {items.map((itemData, index) => {
                            const itemName = isDress ? itemData.item.dressName : itemData.item.suitName;
                            return (
                              <ListItem key={index} divider sx={{ pl: 2 }} secondaryAction={<><Tooltip title={`Cambiar ${itemType}`}><span><IconButton size="small" edge="end" sx={{ mr: 0.5 }} onClick={(e) => { e.stopPropagation(); handleEditItem(service, itemData); }}><EditIcon fontSize="small" /></IconButton></span></Tooltip><Tooltip title={`Quitar ${itemType}`}><span><IconButton size="small" edge="end" onClick={(e) => { e.stopPropagation(); handleDeleteItem(service, itemData); }}><DeleteOutlineIcon fontSize="small" color="error" /></IconButton></span></Tooltip></>}>
                                <ListItemText primaryTypographyProps={{ variant: 'body2', noWrap: true }} primary={itemName} secondary={`Código: ${itemData.item.code}`} />
                              </ListItem>
                            );
                          })}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  );
                }
                return (
                  <Box key={service.serviceID ?? service.serviceName} onClick={() => handleSelectedServiceChanges(service)} sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', backgroundColor: isSelected ? '#e6f2f3' : 'transparent', borderLeft: isSelected ? '5px solid #f759ab' : 'none', borderBottom: '1px solid #eee' }}>
                    <Box sx={{ flex: 3 }}><Typography variant="subtitle2" component="div" fontWeight="bold" noWrap>{service.serviceName}</Typography><Typography variant="caption">{service.quantity} × RD$ {formatCurrency(service.discountApplied > 0 ? safeParseFloat(service.priceWDisc) : safeParseFloat(service.servicePrice))}{service.discountApplied > 0 && ` (Desc. ${service.discountApplied}%)`}</Typography></Box>
                    <Box textAlign="right" sx={{ flex: 2 }}><Typography variant="subtitle2" fontWeight="bold">RD$ {formatCurrency(service.totalPrice)}</Typography><Typography variant="caption" color={service.paymentStatus === PAYMENT_STATUS_PAID ? 'green' : 'orange'}>(RD$ {formatCurrency(service.amountPaid)} pagados)</Typography></Box>
                    <IconButton size="small" sx={{ ml: 0.5 }} onClick={(e) => { e.stopPropagation(); deleteArrOfSelectedServices(service); }}><DeleteOutlineIcon fontSize="small" sx={{ color: 'red' }} /></IconButton>
                  </Box>
                );
              })}
            </Box>
          </Paper>
          <Paper elevation={2} sx={{ p: 1, mb: 1, textAlign: 'right' }}><Typography variant="h6">Total: RD$ {formatCurrency(calculateTotal())}</Typography></Paper>
          <Paper elevation={2} sx={{ p: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <NumericKeypad onKeyClick={handleKeyClick}
                onBackspaceClick={handleBackspaceClick}
                onClearClick={handleClearClick}
                isQtyActive={changeQty}
                isPriceActive={changePrice}
                isDiscountActive={changeDiscount}
                onActiveChangeQty={handleActiveChangeQty}
                onActiveChangePrice={handleActiveChangePrice}
                onActiveChangeDiscount={handleActiveChangeDiscount}
                disabled={!selectedService}
                qtyDisabled={selectedService?.serviceType === DRESS_SERVICE_TYPE || selectedService?.serviceType === SUIT_SERVICE_TYPE}
                isMobile={true}
              />
              <Box sx={{ display: 'flex', justifyContent: 'space-around', width: '100%', mt: 1 }}>
                <Tooltip title={paidService ? 'Marcar como NO pagado' : 'Marcar como pagado (completo)'}><span>{paidService ? <IconButton><AttachMoneyIcon alt='attach-money' style={{ width: '40px', height: '40px', color: 'green' }} onClick={handleInactivePaidService} /></IconButton> : <IconButton><MoneyOffIcon style={{ width: '40px', height: '40px', color: 'red' }} onClick={handleActivePaidService} /></IconButton>}</span></Tooltip>
                <Tooltip title='Editar monto pagado'><span>{(paidService && editPaidService) ? <IconButton><img src={Bill} alt='bill' style={{ width: '40px', height: '40px' }} onClick={handleActiveEditPaidService} /></IconButton> : <IconButton><img src={BillBlack} alt='bill' style={{ width: '40px', height: '40px' }} onClick={handleActiveEditPaidService} /></IconButton>}</span></Tooltip>
              </Box>
            </Box>
          </Paper>
        </Box>
        <Paper elevation={3} sx={{ position: 'sticky', bottom: '10px', left: 0, right: 0, p: 1, zIndex: 999, backgroundColor: 'white' }}>
          <Box sx={{ flex: 1, width: { xs: '100%', sm: 'auto' }, minWidth: { sm: '80px' }, position: 'relative', mb: 1 }}><Button fullWidth variant="outlined" size="large" onClick={handleOpen} startIcon={<PeopleOutlineIcon sx={{ color: '#f759ab' }} />} sx={{ justifyContent: 'flex-start', textTransform: 'none', py: 1.5, borderColor: '#e0e0e0', backgroundColor: '#f8f9fa', '&:hover': { borderColor: '#bdbdbd', backgroundColor: '#f1f3f5' } }}><Typography variant="body1" noWrap sx={{ maxWidth: '240px', color: selectedClient?.clientName ? 'text.primary' : 'text.disabled', fontWeight: 500 }}>{selectedClient?.clientName || 'Seleccionar cliente'}</Typography></Button><Tooltip title="Haz clic para seleccionar o agregar cliente" arrow placement="top"><IconButton size="small" sx={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', color: 'text.secondary' }}><ArrowDropDownIcon /></IconButton></Tooltip></Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}><Button variant='contained' onClick={(e) => handleToCheckOut(e)} sx={{ flexGrow: 1, ml: 0.5, backgroundColor: '#f759ab', '&:hover': { backgroundColor: '#eb2f96' } }}>Proceder</Button></Box>
        </Paper>
        {!isServiceSelectorOpen && (<Fab color="secondary" aria-label="Seleccionar Servicios" onClick={openServiceSelector} sx={{ position: 'fixed', bottom: 80, left: '85%', transform: 'translateX(-50%)', zIndex: 1000, backgroundColor: '#f759ab', '&:hover': { backgroundColor: '#eb2f96' } }}><ArrowUpwardIcon /></Fab>)}
        <Paper elevation={4} sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: '100dvh', backgroundColor: 'white', zIndex: 9001, display: 'flex', flexDirection: 'column', transform: isServiceSelectorOpen ? 'translateY(0)' : 'translateY(100%)', transition: 'transform 0.3s ease-in-out', overflow: 'hidden', width: '100dvw', maxWidth: '100dvw' }}>
          <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'aliceblue', borderBottom: '1px solid #ccc' }}><Typography variant="h6" sx={{ color: '#f759ab' }}>Seleccionar Servicios</Typography><IconButton onClick={closeServiceSelector}><CloseIcon /></IconButton></Box>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%', bgcolor: 'background.paper' }}><Tabs value={serviceType} onChange={handleTabChange} variant="scrollable" aria-label="Tipos de servicio" sx={{ '& .MuiTabs-indicator': { backgroundColor: '#f759ab' }, '& .MuiTab-root': { color: theme.palette.text.secondary, minWidth: 70, fontSize: '0.75rem', padding: '6px 8px', '&.Mui-selected': { color: '#f759ab', fontWeight: 'bold' } } }}>{tabOptions.filter(t => t.serviceType !== 'Eventos').map(t => <Tab key={t.serviceType} label={t.serviceType.length > 10 ? `${t.serviceType.substring(0, 8)}..` : t.serviceType} value={t.serviceType} />)}</Tabs></Box>
          <Grid container spacing={2} sx={{ flexGrow: 1, overflowY: 'auto', p: 1, alignContent: 'start' }}>{services.filter(s => s.serviceType === serviceType).map(s => <Grid item xs={6} sm={4} key={s.serviceID ?? s.serviceName + '-mobile-card'}><ServiceCard service={s} handleSelectedService={handleMobileServiceSelected} isMobile={true} /></Grid>)}</Grid>
        </Paper>
      </Box>
    );
  };

  const DesktopView = React.memo(({ arrOfSelectedServices, selectedService, handleSelectedServiceChanges, deleteArrOfSelectedServices, calculateTotal, handleKeyClick, handleBackspaceClick, handleClearClick, changePrice, changeQty, handleActiveChangeQty, handleActiveChangePrice, changeDiscount, handleActiveChangeDiscount, paidService, handleInactivePaidService, handleActivePaidService, editPaidService, handleActiveEditPaidService, handleOpen, selectedClient, handleToCheckOut, tabOptions, serviceType, services, handleArrOfSelectedServices, handleTabChange }) => {
    const theme = useTheme();
    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', height: 'calc(100vh - 74px)', position: 'relative', overflow: 'hidden' }}>
        <Box sx={{ width: { xs: '100%', md: '35%' }, minWidth: { md: '400px' }, borderRight: { md: '1px solid #e0e0e0' }, display: 'flex', flexDirection: 'column', backgroundColor: '#fff', height: 'calc(100vh - 74px)' }}>
          <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Typography variant="h6" sx={{ color: '#4D92CC', fontWeight: 600 }}><AssignmentIcon sx={{ mr: 1, verticalAlign: 'middle' }} />Servicios Seleccionados</Typography></Box>
            <Box sx={{ flex: 1, overflowY: 'scroll', p: 2, height: '45vh', '&::-webkit-scrollbar': { width: '6px' }, '&::-webkit-scrollbar-track': { background: '#f5f5f5' }, '&::-webkit-scrollbar-thumb': { background: '#e0e0e0' } }}>
              {arrOfSelectedServices?.map((service, key) => (
                <React.Fragment key={key}>
                  {((service.serviceType === DRESS_SERVICE_TYPE && service.dresses) || (service.serviceType === SUIT_SERVICE_TYPE && service.suits)) ? (() => {
                    const isDress = service.serviceType === DRESS_SERVICE_TYPE;
                    const items = isDress ? service.dresses : service.suits;
                    const itemType = isDress ? 'vestido' : 'traje';
                    return (
                      <Accordion sx={{ mb: 2, boxShadow: selectedService?.serviceName === service.serviceName ? '0 0 0 2px #e91e63' : '0 1px 2px rgba(0,0,0,0.08)', '&:before': { display: 'none' } }} onClick={() => handleSelectedServiceChanges(service)}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Box>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{service.serviceName}</Typography>
                              <Typography variant="body2" color="text.secondary">
                                {service.quantity} {itemType}{service.quantity > 1 ? 's' : ''}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {service.quantity} x RD$ {formatCurrency(safeParseFloat(service.servicePrice))}
                              </Typography>
                            </Box>
                            <Box textAlign="right">
                              <Typography variant="subtitle1" sx={{ fontWeight: 700, pr: 2 }}>
                                RD$ {formatCurrency(service.totalPrice)}
                              </Typography>
                              {
                                service.discountApplied > 0 && (
                                  <Typography variant="caption" color="text.secondary" sx={{ color: 'error.main', fontStyle: 'italic', fontSize: '0.75rem' }}>
                                    Descuento apl.: {service.discountApplied}%
                                  </Typography>
                                )
                              }
                            </Box>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0 }}>
                          <List dense>
                            {items.map((itemData, index) => {
                              const itemName = isDress ? itemData.item.dressName : itemData.item.suitName;
                              return (
                                <ListItem key={index} divider secondaryAction={<><Tooltip title={`Cambiar ${itemType}`}><span><IconButton edge="end" sx={{ mr: 0.5 }} onClick={(e) => { e.stopPropagation(); handleEditItem(service, itemData); }}><EditIcon /></IconButton></span></Tooltip><Tooltip title={`Quitar ${itemType}`}><span><IconButton edge="end" onClick={(e) => { e.stopPropagation(); handleDeleteItem(service, itemData); }}><DeleteOutlineIcon color="error" /></IconButton></span></Tooltip></>}>
                                  <ListItemText primary={itemName} secondary={`Código: ${itemData.item.code}`} />
                                </ListItem>
                              );
                            })}
                          </List>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })() : (
                    <Card sx={{ mb: 2, cursor: 'pointer', transition: 'all 0.3s ease', boxShadow: selectedService?.serviceName === service.serviceName ? '0 0 0 2px #e91e63' : '0 1px 2px rgba(0,0,0,0.08)', '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.15)', transform: 'translateY(-2px)' } }} onClick={() => handleSelectedServiceChanges(service)}>
                      <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', p: 2, '&:last-child': { pb: 2 } }}>
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pr: 2 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary', lineHeight: 1.2 }}>{service.serviceName}</Typography>
                          {service.discountApplied ? (<Box><Typography variant="body2" sx={{ color: 'text.secondary' }}>{service.quantity} {service.quantity > 1 ? 'unidades' : 'unidad'} × RD$ {formatCurrency(safeParseFloat(service.priceWDisc))}</Typography><Typography variant="body2" sx={{ color: 'error.main', fontStyle: 'italic', fontSize: '0.75rem' }}>Descuento apl.: {service.discountApplied}%</Typography></Box>) : (<Typography variant="body2" sx={{ color: 'text.secondary' }}>{service.quantity} {service.quantity > 1 ? 'unidades' : 'unidad'} × RD$ {formatCurrency(safeParseFloat(service.servicePrice))}</Typography>)}
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5, minWidth: '100px', pr: 4 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>RD$ {formatCurrency(service.totalPrice)}</Typography>
                          {service.amountPaid > 0 ? (<Typography variant="caption" sx={{ color: 'success.main', fontWeight: 500 }}>RD$ {formatCurrency(service.amountPaid)} pagados</Typography>) : (<Typography variant="caption" sx={{ color: 'text.disabled' }}>RD$ 0 pagados</Typography>)}
                        </Box>
                        <Tooltip title="Quitar servicio" arrow><span><IconButton sx={{ position: 'absolute', right: 4, top: 4, color: 'error.main', p: 0.5, '&:hover': { backgroundColor: 'rgba(255, 23, 68, 0.1)', transform: 'scale(1.1)' } }} onClick={(e) => { e.stopPropagation(); deleteArrOfSelectedServices(service); }}><DeleteOutlineIcon fontSize="medium" /></IconButton></span></Tooltip>
                      </CardContent>
                    </Card>
                  )}
                </React.Fragment>
              ))}
            </Box>
          </Box>
          <Box sx={{ borderTop: '1px solid #e0e0e0', p: 2, bgcolor: '#fff' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}><Typography variant="h6">Total:</Typography><Typography variant="h6" sx={{ fontWeight: 700 }}>RD$ {calculateTotal().toLocaleString('en-US', { minimumFractionDigits: 2 })}</Typography></Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: '8px', p: 2 }}>
                <NumericKeypad onKeyClick={handleKeyClick}
                  onBackspaceClick={handleBackspaceClick}
                  onClearClick={handleClearClick}
                  isPriceActive={changePrice}
                  isQtyActive={changeQty}
                  onActiveChangeQty={handleActiveChangeQty}
                  onActiveChangePrice={handleActiveChangePrice}
                  isDiscountActive={changeDiscount}
                  onActiveChangeDiscount={handleActiveChangeDiscount}
                  disabled={!selectedService}
                  qtyDisabled={selectedService?.serviceType === DRESS_SERVICE_TYPE || selectedService?.serviceType === SUIT_SERVICE_TYPE}
                />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'row', sm: 'column' }, gap: 1, width: { sm: '50px' } }}>
                <span style={{ height: '50%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>{paidService ? <Tooltip title='No contabilizar servicio' placement='right'><IconButton><AttachMoneyIcon alt='attach-money' style={{ width: '40px', height: '40px', color: 'green' }} onClick={handleInactivePaidService} /></IconButton></Tooltip> : <Tooltip title='Contabilizar servicio' placement='right'><IconButton><MoneyOffIcon style={{ width: '40px', height: '40px', color: 'red' }} onClick={handleActivePaidService} /></IconButton></Tooltip>}</span>
                <span style={{ height: '50%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}><Tooltip title='Editar monto pagado' placement='right'>{(paidService && editPaidService) ? <IconButton><img src={Bill} alt='bill' style={{ width: '40px', height: '40px' }} onClick={handleActiveEditPaidService} /></IconButton> : <IconButton><img src={BillBlack} alt='bill' style={{ width: '40px', height: '40px' }} onClick={handleActiveEditPaidService} /></IconButton>}</Tooltip></span>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: 'center', width: '100%', mt: 2 }}>
              <Box sx={{ flex: 1, width: { xs: '100%', sm: 'auto' }, minWidth: { sm: '80px' }, position: 'relative' }}><Button fullWidth variant="outlined" size="large" onClick={handleOpen} startIcon={<PeopleOutlineIcon sx={{ color: '#f759ab' }} />} sx={{ justifyContent: 'flex-start', textTransform: 'none', py: 1.5, borderColor: '#e0e0e0', backgroundColor: '#f8f9fa', '&:hover': { borderColor: '#bdbdbd', backgroundColor: '#f1f3f5' } }}><Typography variant="body1" noWrap sx={{ maxWidth: '240px', color: selectedClient?.clientName ? 'text.primary' : 'text.disabled', fontWeight: 500 }}>{selectedClient?.clientName || 'Seleccionar cliente'}</Typography></Button><Tooltip title="Haz clic para seleccionar o agregar cliente" arrow placement="top"><IconButton size="small" sx={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', color: 'text.secondary' }}><ArrowDropDownIcon /></IconButton></Tooltip></Box>
              <Button fullWidth variant="contained" size="large" sx={{ flexShrink: 0, width: { xs: '100%', sm: 'auto' }, minWidth: '80px', bgcolor: '#f759ab', fontWeight: 600, '&:hover': { bgcolor: '#eb2f96' } }} onClick={(e) => handleToCheckOut(e)}>Proceder al Pago</Button>
            </Box>
          </Box>
        </Box>
        <Box sx={{ flex: 1, backgroundColor: '#fff', p: { xs: 1, md: 3 }, overflow: 'hidden' }}>
          <Box sx={{ mb: 3, overflowX: 'auto' }}><Tabs value={serviceType} onChange={handleTabChange} variant="scrollable" aria-label="Tipos de servicio" sx={{ '& .MuiTabs-indicator': { backgroundColor: '#f759ab' }, '& .MuiTab-root': { color: theme.palette.text.secondary, minWidth: 70, fontSize: '0.75rem', padding: '6px 8px', '&.Mui-selected': { color: '#f759ab', fontWeight: 'bold' } } }}>{tabOptions.filter(t => t.serviceType !== 'Eventos').map(t => <Tab key={t.serviceType} label={t.serviceType.length > 10 ? `${t.serviceType.substring(0, 8)}..` : t.serviceType} value={t.serviceType} />)}</Tabs></Box>
          <Grid container spacing={2} sx={{ p: 1, height: 'calc(100% - 100px)', overflowY: 'auto', mb: 10, pb: 2 }}>{serviceType && services.filter(s => s.serviceType === serviceType).map((service, index) => <Grid item key={index} xs={12} sm={6} md={4} lg={3} xl={2} sx={{ display: 'flex', justifyContent: 'center' }}><ServiceCard service={service} handleSelectedService={handleArrOfSelectedServices} /></Grid>)}</Grid>
        </Box>
      </Box>
    );
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: 'Calc(100vh - 104px)', backgroundColor: '#f5f5f5', height: 'Calc(100vh - 74px)', maxHeight: 'Calc(100vh - 74px)', overflow: 'hidden' }}>
      {contextHolder}
      {isMobile ? <MobileView /> : <DesktopView {...{ arrOfSelectedServices, selectedService, handleSelectedServiceChanges, deleteArrOfSelectedServices, calculateTotal, handleKeyClick, handleBackspaceClick, handleClearClick, changePrice, changeQty, handleActiveChangeQty, handleActiveChangePrice, changeDiscount, handleActiveChangeDiscount, paidService, handleInactivePaidService, handleActivePaidService, editPaidService, handleActiveEditPaidService, handleOpen, selectedClient, handleToCheckOut, tabOptions, serviceType, services, handleArrOfSelectedServices, handleTabChange }} />}
      {/* --- Diálogos Modales para Vestidos (Usando el componente original) --- */}
      <RentDressServiceDialog
        open={openXVDressDialog}
        onClose={() => { setOpenXVDressDialog(false); setEditingItem(null); }}
        onSelect={handleSelectedDress}
        dressList={XVDressList}
        dressSelectionService={itemSelectionService}
        dressReservations={dressReservations}
        newDressReservation={newDressReservation}
      />
      <RentDressServiceDialog
        open={openWDressDialog}
        onClose={() => { setOpenWDressDialog(false); setEditingItem(null); }}
        onSelect={handleSelectedDress}
        dressList={WDressList}
        dressSelectionService={itemSelectionService}
        dressReservations={dressReservations}
        newDressReservation={newDressReservation}
      />
      <RentDressServiceDialog
        open={openPersonalDressDialog}
        onClose={() => { setOpenPersonalDressDialog(false); setEditingItem(null); }}
        onSelect={handleSelectedDress}
        dressList={personalDressList}
        dressSelectionService={itemSelectionService}
        dressReservations={dressReservations}
        newDressReservation={newDressReservation}
      />
      <RentDressServiceDialog
        open={openChildDressDialog}
        onClose={() => { setOpenChildDressDialog(false); setEditingItem(null); }}
        onSelect={handleSelectedDress}
        dressList={childDressList}
        dressSelectionService={itemSelectionService}
        dressReservations={dressReservations}
        newDressReservation={newDressReservation}
      />

      {/* --- DIÁLOGO MODAL GENÉRICO PARA TRAJES (Usando el nuevo componente) --- */}
      <RentableItemDialog
        open={openSuitDialog}
        onClose={() => { setOpenSuitDialog(false); setEditingItem(null); }}
        onSelect={handleSelectedSuit}
        itemList={suitList} // Se pasa la lista de trajes
        itemSelectionService={itemSelectionService}
        itemReservations={suitReservations} // Se pasan las reservaciones de trajes
        newReservations={newDressReservation}
        itemType="traje" // Se especifica el tipo para personalizar el texto
      />

      <RentableItemDialog
        open={openChildSuitDialog}
        onClose={() => { setOpenChildSuitDialog(false); setEditingItem(null); }}
        onSelect={handleSelectedSuit}
        itemList={childSuitList} // Se pasa la lista de trajes
        itemSelectionService={itemSelectionService}
        itemReservations={suitReservations} // Se pasan las reservaciones de trajes
        newReservations={newDressReservation}
        itemType="traje" // Se especifica el tipo para personalizar el texto
      />

      {/* --- Diálogos de Cliente --- */}
      <ClientDialog
        open={open}
        onClose={handleClose}
        handleClose={handleClose}
        clients={clientsList}
        handleOpenTwo={() => { setSelectedClient({}); handleClose(); setOpenDiagTwo(true); }}
        handleClientSelectionChange={handleClientSelectionChange}
        selectedClient={selectedClient}
        handleCancel={() => { setSelectedClient({}); handleClose(); }}
      />
      <NewClientDialog
        openDiagTwo={openDiagTwo}
        handleCloseTwo={() => setOpenDiagTwo(false)}
        handleCancelTwo={() => { setSelectedClient({}); setOpenDiagTwo(false); }}
        handleClientCreation={handleClientCreation}
      />
    </Box>
  );
};

export default BillingServiceSelector;